import { render, staticRenderFns } from "./Accident.vue?vue&type=template&id=5783c191&scoped=true&"
import script from "./Accident.vue?vue&type=script&lang=js&"
export * from "./Accident.vue?vue&type=script&lang=js&"
import style0 from "./Accident.vue?vue&type=style&index=0&id=5783c191&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5783c191",
  null
  
)

export default component.exports